import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function OldSolutionsFail() {
  const solutions = [{
    title: 'Presupuestos detallados',
    reason: 'Requieren energía diaria y tracking. Cuando estás agotada, los abandonas.'
  }, {
    title: 'Apps de finanzas',
    reason: 'Te hacen contadora. Las descargas, las usas 3 días, y las abandonas.'
  }, {
    title: '"Solo ahorra"',
    reason: 'No te dice qué hacer esta semana. Es un consejo sin sistema.'
  }, {
    title: 'Cash stuffing total',
    reason: 'Choca con autopay y bills digitales. No encaja con tu vida real.'
  }];
  return <section className="py-20 px-6 bg-cream border-t border-warm-gray/10" data-id="element-114">
      <div className="max-w-4xl mx-auto" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-116">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-6" data-id="element-117">
            Por qué nada te ha funcionado
            <br data-id="element-118" />
            <span className="block" data-id="element-119">(hasta ahora)</span>
          </h2>

          <div className="relative inline-block mt-4" data-id="element-120">
            <div className="absolute inset-0 bg-forest/5 rounded-2xl transform -rotate-1 scale-105 -z-10" data-id="element-121" />
            <img src="https://cdn.magicpatterns.com/uploads/sdw8b7nTa83YBWNj2KEqgU/3E17E5E6-0326-42C7-A3AD-C168CE223211.png" alt="El Mapa de Pago en 10 Min en tablet" className="rounded-xl shadow-xl w-full max-w-sm mx-auto border border-warm-gray/10" data-id="element-122" />
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-123">
          {solutions.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-sm border-l-4 border-warm-red relative overflow-hidden" data-id="element-124">
              <div className="flex items-start gap-4" data-id="element-125">
                <XCircle className="w-6 h-6 text-warm-red flex-shrink-0 mt-1" data-id="element-126" />
                <div data-id="element-127">
                  <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-128">
                    {item.title}
                  </h3>
                  <p className="text-charcoal/80 leading-relaxed" data-id="element-129">
                    {item.reason}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center max-w-2xl mx-auto" data-id="element-130">
          <p className="text-xl md:text-2xl font-serif text-charcoal leading-relaxed" style={{
          fontSize: '18px',
          textWrap: 'balance'
        }} data-id="element-131">
            Necesitas algo que funcione en{' '}
            <span className="text-forest font-bold" data-id="element-132">10&nbsp;minutos</span>,
            no&nbsp;en&nbsp;10&nbsp;horas. Algo que no requiera disciplina
            perfecta—solo&nbsp;claridad.
          </p>
        </motion.div>
      </div>
    </section>;
}